import React from 'react';
import { useAuth } from '../components/AuthContext';
import { AdminDashboard } from '../components/AdminDashboard';
import { UserDashboard } from '../components/UserDashboard';

export default function Dashboard() {
  const { user } = useAuth();

  // Check if user is admin
  const isAdmin = user?.email === import.meta.env.VITE_ADMIN_EMAIL;

  return isAdmin ? <AdminDashboard /> : <UserDashboard />;
}